import { Header } from './Header';
import { Container } from './Container';
import { Toaster } from '@/components/ui/toaster';

interface LayoutProps {
  children: React.ReactNode;
  containerWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
  className?: string;
}

/**
 * Layout component to structure the application.
 * Includes a Header, a flexible content container, and a global Toaster for notifications.
 * 
 * @param children - The main content to be rendered within the layout.
 * @param containerWidth - Determines the max-width of the main content area.
 * @param className - Additional custom classes to style the container.
 */
export function Layout({
  children,
  containerWidth = 'full',
  className,
}: LayoutProps): JSX.Element {
  return (
    <div className="min-h-screen bg-background">
      {/* Header Section */}
      <Header />

      {/* Main Content Section */}
      <main className="flex-1">
        {containerWidth === 'full' ? (
          <div className={className}>{children}</div>
        ) : (
          <Container maxWidth={containerWidth} className={className}>
            {children}
          </Container>
        )}
      </main>

      {/* Notification Toaster */}
      <Toaster />
    </div>
  );
}
